module.exports = __webpack_public_path__ + "static/media/BankDetailSendMoney.e2d439d8.svg";